<div class="spa-days" role="list" [attr.aria-label]="presenter.viewState().ariaLabel || null">
  <ng-container *ngTemplateOutlet="presenter.viewState().chipsTemplate" />
</div>
